import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Fragment, Suspense, useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { arrayOf, bool, number, shape, string } from 'prop-types';
import { Form } from 'informed';
import { Info } from 'react-feather';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import { useProductFullDetail } from '@magento/peregrine/lib/talons/ProductFullDetail/useProductFullDetail';
import { isProductConfigurable } from '@magento/peregrine/lib/util/isProductConfigurable';
import Breadcrumbs from '@magento/venia-ui/lib/components/Breadcrumbs';
import { Link } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { REQUISITION_LISTS } from 'src/pages/Account/FrequentlyOrderProducts/graphql/actions.gql.js';
import { useStyle } from '@magento/venia-ui/lib/classify';
import FormError from '@magento/venia-ui/lib/components/FormError';
import { QuantityFields } from '@magento/venia-ui/lib/components/CartPage/ProductListing/quantity';
import { ProductOptionsShimmer } from '@magento/venia-ui/lib/components/ProductOptions';
import defaultClasses from './productFullDetail.module.css';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { useUserContext } from '@magento/peregrine/lib/context/user/';
import ProductSlider from './productSlider';
import { useDrawer } from './hooks/useDrawer';
import Drawer from './Drawer/drawer';
import { Button, RichContent, AppBodyLayout, Accordion, DownArrow } from '../../../../components';
import SignInModal from '../../../../components/Favorites/SignInModal/index';
import Specifications from './Specifications/specifications';
import AvailableOutlet from './AvailableOutlet/availableOutlet';
import ItemSkuInfo from './ItemSkuInfo';
import Price from '../Price';
import ProductListSlider from './productListSlider';
import { useToasts } from '@magento/peregrine'; // import LoadingIndicator from '@magento/venia-ui/lib/components/LoadingIndicator';

import CmsBlock from '../../../../components/Cms/cmsBlock'; // import CMSPage from '../../../../components/Cms/cms';

import Tearsheet from 'src/components/Tearsheet';
import GetCandid from '../../../pagebuilder/ContentTypes/GetCandid';
import { getCustomerGroup } from '../../../../Utils/utils';
import useCompanyPermissions from '../../../../hooks/useCompanyPermissions';
import DownloadsPopup from './downloadsPopup';
import FrequentlyOrderedModal from '../../../../components/FrequentlyOrderedModal';
import AdditionalFeatureItem from './common/additionalFeaturesItem';
import SectionTitle from './common/sectionTitle';
import arrowDown from '../../../../assets/downArrowSelect.svg';
import VideoComponent from './VideoComponent';
import { useAvailableOutlet } from '../../../peregrine/talons/ProductFullDetail/AvailableOutlet/useAvailableOutlet';
import CSPortalDetails from './CSPortalDetails/csPortalDetails';
import downloadIcon from '../../../../assets/DownloadSimple.svg';
import editIcon from '../../../../assets/edit-icon.svg';
import { VIEW_ITEM } from '../../../../graphql/magefan.gql';
var MiddleDialog = React.lazy(function () {
  return import('../../../../components/Favorites/MiddleDialog');
});
var WishlistButton = React.lazy(function () {
  return import('src/overrides/venia-ui/components/Wishlist/AddToListPdpButton');
});
var Options = React.lazy(function () {
  return import('@magento/venia-ui/lib/components/ProductOptions');
}); // Correlate a GQL error message to a field. GQL could return a longer error
// string but it may contain contextual info such as product id. We can use
// parts of the string to check for which field to apply the error.

var ERROR_MESSAGE_TO_FIELD_MAPPING = {
  'The requested qty is not available': 'quantity',
  'Product that you are trying to add is not available.': 'quantity',
  "The product that was requested doesn't exist.": 'quantity'
}; // Field level error messages for rendering.

var ERROR_FIELD_TO_MESSAGE_MAPPING = {
  quantity: 'The requested quantity is not available.'
};

var ProductFullDetail = function ProductFullDetail(_ref) {
  var _product$sku, _productDetails$sku, _product$configurable, _product$configurable2, _product$configurable3, _configCustomAttribut, _fopData$customer, _fopData$customer$req, _fopData$customer$req2, _product$custom_attri2, _product$custom_attri3, _product$custom_attri4, _product$price_range, _product$price_range$, _product$price_range$2, _product$price_range2, _product$price_range3, _product$price_range4, _product$price_range5, _product$price_range6, _product$price_range7, _product$price_range8, _product$price_range9, _product$price_range10, _productDetails$price, _productDetails$price2, _product$price, _product$price$regula, _product$price$regula2, _product$price_range11, _product$price_range12, _product$price_range13, _product$price_range14, _product$price_range15, _product$price_range16, _productDetails$price3, _productDetails$price4, _customAttributes$fin, _customAttributes$fin2, _customAttributes$fin3, _customAttributes$fin4, _relatedProducts$cros;

  var product = _ref.product,
      propClasses = _ref.classes;
  var talonProps = useProductFullDetail({
    product: product
  });
  var breadcrumbCategoryId = talonProps.breadcrumbCategoryId,
      errorMessage = talonProps.errorMessage,
      handleAddToCart = talonProps.handleAddToCart,
      handleSelectionChange = talonProps.handleSelectionChange,
      isOutOfStock = talonProps.isOutOfStock,
      isAddToCartDisabled = talonProps.isAddToCartDisabled,
      isSupportedProductType = talonProps.isSupportedProductType,
      mediaGallery = talonProps.mediaGallery,
      productDetails = talonProps.productDetails,
      wishlistButtonProps = talonProps.wishlistButtonProps,
      defaultOptionSelection = talonProps.defaultOptionSelection,
      disabledValuesMap = talonProps.disabledValuesMap,
      configuredItemId = talonProps.configuredItemId,
      configuredSmartString = talonProps.configuredSmartString,
      customAttributes = talonProps.customAttributes,
      weight = talonProps.weight,
      successAddToCartToast = talonProps.successAddToCartToast,
      handleResetProductConfiguration = talonProps.handleResetProductConfiguration,
      isReset = talonProps.isReset,
      optionSelections = talonProps.optionSelections,
      handleAddProductToQuote = talonProps.handleAddProductToQuote,
      configCustomAttributes = talonProps.configCustomAttributes,
      collectionsData = talonProps.collectionsData,
      relatedProducts = talonProps.relatedProducts,
      selectedOptionsArray = talonProps.selectedOptionsArray,
      defaultSmartStringSelected = talonProps.defaultSmartStringSelected,
      isInFavorites = talonProps.isInFavorites,
      refetchFavorites = talonProps.refetchFavorites,
      configuredVariant = talonProps.configuredVariant,
      setOptionSelections = talonProps.setOptionSelections,
      setProductConfiguration = talonProps.setProductConfiguration,
      tagValues = talonProps.tagValues;

  var _useQuery = useQuery(REQUISITION_LISTS, {
    fetchPolicy: 'no-cache' // fetchPolicy: 'cache-and-network',
    // nextFetchPolicy: 'cache-first'

  }),
      fopData = _useQuery.data,
      refetch = _useQuery.refetch,
      loadingReq = _useQuery.loading;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var classes = useStyle(defaultClasses, propClasses);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      isWishlistDialogOpen = _useState2[0],
      setIsWishlistDialogOpen = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      localQuantity = _useState4[0],
      setLocalQuantity = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isReadMore = _useState6[0],
      setReadMore = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedForFoP = _useState8[0],
      setSelectedForFoP = _useState8[1];

  var _useDrawer = useDrawer(),
      activateDrawer = _useDrawer.activateDrawer,
      handleDrawerActions = _useDrawer.handleDrawerActions,
      closeDrawer = _useDrawer.closeDrawer,
      drawerRef = _useDrawer.drawerRef;

  var _getCustomerGroup = getCustomerGroup(),
      isCustomerServiceTeam = _getCustomerGroup.isCustomerServiceTeam,
      isConsumer = _getCustomerGroup.isConsumer,
      isTradeDirectAccount = _getCustomerGroup.isTradeDirectAccount,
      isResDesigner = _getCustomerGroup.isResDesigner,
      isNonStockDealers = _getCustomerGroup.isNonStockDealers,
      isWholesaleDealer = _getCustomerGroup.isWholesaleDealer,
      isResReps = _getCustomerGroup.isResReps,
      isHfEmployee = _getCustomerGroup.isHfEmployee,
      isComPurchasing = _getCustomerGroup.isComPurchasing,
      isComNonPurchasing = _getCustomerGroup.isComNonPurchasing;

  var availableRef = useRef();
  var otherUser = isTradeDirectAccount || isNonStockDealers || isWholesaleDealer || isHfEmployee;

  var _useCompanyPermission = useCompanyPermissions(),
      canViewPricingAndPurchase = _useCompanyPermission.canViewPricingAndPurchase;

  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 2),
      drawer = _useAppContext2[0].drawer,
      _useAppContext2$ = _useAppContext2[1],
      toggleDrawer = _useAppContext2$.toggleDrawer,
      defaultCloseDrawer = _useAppContext2$.closeDrawer;

  var isOpen = drawer === 'signInModal';
  var videoModal = drawer === 'videoModal';

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      modalData = _useState10[0],
      setModalData = _useState10[1];

  var isFOPOpen = modalData === 'ADD_FREQUENTLY_ORDER' && selectedForFoP && selectedForFoP.id === (product === null || product === void 0 ? void 0 : product.id);
  var isSignInModalOpen = modalData === 'SIGN_IN';
  var isMiddleDialogOpen = modalData === 'MIDDLE_DIALOG';
  var isTearsheetOpen = drawer === 'pdpTearsheetDownload';

  var _useAvailableOutlet = useAvailableOutlet({
    outletSku: product !== null && product !== void 0 && (_product$sku = product.sku) !== null && _product$sku !== void 0 && _product$sku.includes('OUT') ? product === null || product === void 0 ? void 0 : product.sku : "OUT-".concat(product === null || product === void 0 ? void 0 : product.sku)
  }),
      isAvailableInOutletLink = _useAvailableOutlet.isAvailableInOutletLink; // const isAvailableInOutletLink = false;


  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  var isOutletProduct = productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$sku = productDetails.sku) === null || _productDetails$sku === void 0 ? void 0 : _productDetails$sku.startsWith('OUT-');
  var isSaleable = isOutletProduct || isUserSignedIn;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isMobile = innerWidth <= 768;
  var showPdfOptions = useMemo(function () {
    return isUserSignedIn && !isConsumer;
  }, [isConsumer, isUserSignedIn]);

  var _useMutation = useMutation(VIEW_ITEM),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      viewItem = _useMutation2[0];

  useEffect(function () {
    if (product !== null && product !== void 0 && product.id) viewItem({
      variables: {
        productId: product.id
      }
    })["catch"](function (err) {
      return console.error(err);
    });
  }, [product]); // product.configurable_options[0].values[0].label = "test?";

  var derivedConfigOptions = JSON.parse(JSON.stringify(product !== null && product !== void 0 && product.configurable_options ? product === null || product === void 0 ? void 0 : (_product$configurable = product.configurable_options) === null || _product$configurable === void 0 ? void 0 : _product$configurable.filter(function (option) {
    return option.attribute_code != 'hf_option1' && option.attribute_code != 'hf_option2';
  }) : '{}'));

  var optionOne = _objectSpread({}, product === null || product === void 0 ? void 0 : (_product$configurable2 = product.configurable_options) === null || _product$configurable2 === void 0 ? void 0 : _product$configurable2.find(function (option) {
    return option.attribute_code == 'hf_option1';
  }));

  var optionTwo = _objectSpread({}, product === null || product === void 0 ? void 0 : (_product$configurable3 = product.configurable_options) === null || _product$configurable3 === void 0 ? void 0 : _product$configurable3.find(function (option) {
    return option.attribute_code == 'hf_option2';
  }));

  if (optionOne !== null && optionOne !== void 0 && optionOne.values) {
    var _optionOne$values$;

    optionOne.label = !!(optionOne !== null && optionOne !== void 0 && (_optionOne$values$ = optionOne.values[0]) !== null && _optionOne$values$ !== void 0 && _optionOne$values$.default_label.match(/\[S[^S]/g)) ? 'Shade' : 'Glass';
    derivedConfigOptions.push(optionOne);
  }

  if (optionTwo !== null && optionTwo !== void 0 && optionTwo.values) {
    var _optionTwo$values$;

    optionTwo.label = !!(optionTwo !== null && optionTwo !== void 0 && (_optionTwo$values$ = optionTwo.values[0]) !== null && _optionTwo$values$ !== void 0 && _optionTwo$values$.default_label.match(/\[S[^S]/g)) ? 'Shade' : 'Glass';
    derivedConfigOptions.push(optionTwo);
  }

  if (Array.isArray(derivedConfigOptions)) {
    derivedConfigOptions.forEach(function (item) {
      return item.values = item.values.filter( // value.value_index
      function (value) {
        return product.variants.find(function (variant) {
          return variant.attributes.find(function (variant_attr) {
            return variant_attr.code == item.attribute_code && variant_attr.value_index == value.value_index;
          });
        });
      });
    });
  }

  var options = isProductConfigurable(product) ? React.createElement(Suspense, {
    fallback: React.createElement(ProductOptionsShimmer, null)
  }, React.createElement(Options, {
    onSelectionChange: handleSelectionChange,
    options: derivedConfigOptions,
    defaultOptionSelection: defaultOptionSelection,
    selectedValues: optionSelections,
    handleDrawerActions: handleDrawerActions,
    disabledValuesMap: disabledValuesMap,
    isReset: isReset
  })) : null;
  var breadcrumbs = breadcrumbCategoryId ? React.createElement(Breadcrumbs, {
    categoryId: breadcrumbCategoryId,
    currentProduct: productDetails.name,
    classes: {
      link: 'leading-233'
    }
  }) : null; // Fill a map with field/section -> error.

  var errors = new Map();

  if (errorMessage) {
    Object.keys(ERROR_MESSAGE_TO_FIELD_MAPPING).forEach(function (key) {
      if (errorMessage.includes(key)) {
        var target = ERROR_MESSAGE_TO_FIELD_MAPPING[key];
        var message = ERROR_FIELD_TO_MESSAGE_MAPPING[target];
        errors.set(target, message);
      }
    }); // Handle cases where a user token is invalid or expired. Preferably
    // this would be handled elsewhere with an error code and not a string.

    if (errorMessage.includes('The current user cannot')) {
      errors.set('form', [new Error(formatMessage({
        id: 'productFullDetail.errorToken',
        defaultMessage: 'There was a problem with your cart. Please sign in again and try adding the item once more.'
      }))]);
    } // Handle cases where a cart wasn't created properly.


    if (errorMessage.includes('Variable "$cartId" got invalid value null')) {
      errors.set('form', [new Error(formatMessage({
        id: 'productFullDetail.errorCart',
        defaultMessage: 'There was a problem with your cart. Please refresh the page and try adding the item once more.'
      }))]);
    } // An unknown error should still present a readable message.


    if (!errors.size) {
      errors.set('form', [new Error(formatMessage({
        id: 'productFullDetail.errorUnknown',
        defaultMessage: 'Could not add item to cart. Please check required options and try again.'
      }))]);
    }
  }

  var cartCallToActionText = !isOutOfStock ? React.createElement(FormattedMessage, {
    id: "productFullDetail.addItemToCart",
    defaultMessage: "Add to Cart"
  }) : React.createElement(FormattedMessage, {
    id: "productFullDetail.itemOutOfStock",
    defaultMessage: "Out of Stock"
  });
  var addToQuotesBtn = React.createElement(Button, {
    priority: "low",
    fullWidth: true,
    classes: {
      content: 'uppercase text-h6 leading-160'
    },
    onClick: function onClick() {
      return handleAddProductToQuote({
        sku: product.sku,
        quantity: localQuantity ? localQuantity : 1
      });
    },
    "aria-label": "Add to quote request"
  }, "add to Quote Request");
  var addToCardButton = React.createElement(Button, {
    disabled: isAddToCartDisabled,
    priority: "low",
    fullWidth: true,
    type: "submit",
    "aria-label": cartCallToActionText,
    classes: {
      content: classes.addToCardButton
    }
  }, cartCallToActionText);
  var onlineLocalBtns = // <>
  //     <Button
  //         priority="low"
  //         onClick={() => handleDrawerActions('BUY_LOCAL')}
  //         classes={{ root: classes.notLoggedInBtn }}
  //         aria-label="Buy local"
  //     >
  //         BUY LOCAL
  //     </Button>
  //     {!!customAttributes?.filter(attr =>
  //         attr?.attribute_metadata?.code.includes('hf_product_url')
  //     ).length && (
  //         <Button
  //             priority="low"
  //             onClick={() => handleDrawerActions('BUY_ONLINE')}
  //             classes={{
  //                 root: `${classes.secondActionBtn} ${classes.notLoggedInBtn}`
  //             }}
  //             aria-label="Buy online"
  //         >
  //             BUY ONLINE
  //         </Button>
  //     )}
  // </>
  React.createElement(Button, {
    priority: "low",
    fullWidth: true,
    onClick: function onClick() {
      return handleDrawerActions('BUY_OPTIONS');
    } // classes={{ root: classes.notLoggedInBtn }}
    ,
    "aria-label": "Buy options"
  }, "BUY OPTIONS");
  var cartActionContent = isSupportedProductType ? addToCardButton : React.createElement("div", {
    className: classes.unavailableContainer
  }, React.createElement(Info, null), React.createElement("p", null, React.createElement(FormattedMessage, {
    id: 'productFullDetail.unavailableProduct',
    defaultMessage: 'This product is currently unavailable for purchase.'
  })));
  var storiesValues = configCustomAttributes === null || configCustomAttributes === void 0 ? void 0 : (_configCustomAttribut = configCustomAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_stories';
  })) === null || _configCustomAttribut === void 0 ? void 0 : _configCustomAttribut.selected_attribute_options.attribute_option;
  var storyPosition1 = useMemo(function () {
    var _storiesValues$filter;

    var stories = storiesValues === null || storiesValues === void 0 ? void 0 : (_storiesValues$filter = storiesValues.filter(function (story) {
      var _story$label;

      return story === null || story === void 0 ? void 0 : (_story$label = story.label) === null || _story$label === void 0 ? void 0 : _story$label.startsWith('position1_');
    })) === null || _storiesValues$filter === void 0 ? void 0 : _storiesValues$filter.map(function (story, idx) {
      return React.createElement("div", {
        key: idx,
        className: "mt-5 mb-5 first-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + story.label.replace('position1_', '').toLowerCase()
      }));
    });

    if ((!stories || !(stories !== null && stories !== void 0 && stories.length)) && storiesValues && storiesValues) {
      stories.push(React.createElement("div", {
        className: "mt-5 mb-5 first-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + storiesValues[0].label.toLowerCase()
      })));
    }

    return stories;
  }, [configCustomAttributes]);
  var storyPosition2 = useMemo(function () {
    var _storiesValues$filter2;

    var stories = storiesValues === null || storiesValues === void 0 ? void 0 : (_storiesValues$filter2 = storiesValues.filter(function (story) {
      var _story$label2;

      return story === null || story === void 0 ? void 0 : (_story$label2 = story.label) === null || _story$label2 === void 0 ? void 0 : _story$label2.startsWith('position2_');
    })) === null || _storiesValues$filter2 === void 0 ? void 0 : _storiesValues$filter2.map(function (story, idx) {
      return React.createElement("div", {
        key: idx,
        className: "mt-5 mb-5 second-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + story.label.replace('position2_', '').toLowerCase()
      }));
    });

    if ((!stories || !(stories !== null && stories !== void 0 && stories.length)) && storiesValues && storiesValues[1] !== undefined) {
      stories.push(React.createElement("div", {
        className: "mt-5 mb-5 second-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + storiesValues[1].label.toLowerCase()
      })));
    }

    return stories;
  }, [configCustomAttributes]);
  var storyPosition3 = useMemo(function () {
    var _storiesValues$filter3;

    var stories = storiesValues === null || storiesValues === void 0 ? void 0 : (_storiesValues$filter3 = storiesValues.filter(function (story) {
      var _story$label3;

      return story === null || story === void 0 ? void 0 : (_story$label3 = story.label) === null || _story$label3 === void 0 ? void 0 : _story$label3.startsWith('position3_');
    })) === null || _storiesValues$filter3 === void 0 ? void 0 : _storiesValues$filter3.map(function (story, idx) {
      return React.createElement("div", {
        key: idx,
        className: "mt-5 mb-5 third-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + story.label.replace('position3_', '').toLowerCase()
      }));
    });

    if ((!stories || !(stories !== null && stories !== void 0 && stories.length)) && storiesValues && storiesValues[2] !== undefined) {
      stories.push(React.createElement("div", {
        className: "mt-5 mb-5 third-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + storiesValues[2].label.toLowerCase()
      })));
    }

    return stories;
  }, [configCustomAttributes]);
  var storyPosition4 = useMemo(function () {
    var _storiesValues$filter4;

    var stories = storiesValues === null || storiesValues === void 0 ? void 0 : (_storiesValues$filter4 = storiesValues.filter(function (story) {
      var _story$label4;

      return story === null || story === void 0 ? void 0 : (_story$label4 = story.label) === null || _story$label4 === void 0 ? void 0 : _story$label4.startsWith('position4_');
    })) === null || _storiesValues$filter4 === void 0 ? void 0 : _storiesValues$filter4.map(function (story, idx) {
      return React.createElement("div", {
        key: idx,
        className: "mt-5 mb-5 fourth-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + story.label.replace('position4_', '').toLowerCase()
      }));
    });

    if ((!stories || !(stories !== null && stories !== void 0 && stories.length)) && storiesValues && storiesValues[3] !== undefined) {
      stories.push(React.createElement("div", {
        className: "mt-5 mb-5 fourth-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + storiesValues[3].label.toLowerCase()
      })));
    }

    return stories;
  }, [configCustomAttributes]);
  var storyPosition5 = useMemo(function () {
    var _storiesValues$filter5;

    var stories = storiesValues === null || storiesValues === void 0 ? void 0 : (_storiesValues$filter5 = storiesValues.filter(function (story) {
      var _story$label5;

      return story === null || story === void 0 ? void 0 : (_story$label5 = story.label) === null || _story$label5 === void 0 ? void 0 : _story$label5.startsWith('position5_');
    })) === null || _storiesValues$filter5 === void 0 ? void 0 : _storiesValues$filter5.map(function (story, idx) {
      var _story$label$replace;

      return React.createElement("div", {
        key: idx,
        className: "mt-5 mb-5 fifth-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + ((_story$label$replace = story.label.replace('position5_', '')) === null || _story$label$replace === void 0 ? void 0 : _story$label$replace.toLowerCase())
      }));
    });

    if ((!stories || !(stories !== null && stories !== void 0 && stories.length)) && storiesValues && storiesValues[4] !== undefined) {
      stories.push(React.createElement("div", {
        className: "mt-5 mb-5 fifth-column-story"
      }, React.createElement(CmsBlock, {
        showError: false,
        identifiers: 'story_' + storiesValues[4].label.toLowerCase()
      })));
    }

    return stories;
  }, [configCustomAttributes]);
  var handleOpenModal = useCallback(function (type) {
    return setModalData(type);
  });
  var closeModal = useCallback(function () {
    return setModalData(null);
  });

  var _useToasts = useToasts(),
      _useToasts2 = _slicedToArray(_useToasts, 2),
      addToast = _useToasts2[1].addToast;

  useEffect(function () {
    if (successAddToCartToast) {
      addToast(successAddToCartToast);
    }
  }, [successAddToCartToast]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleReadMore = useCallback(function () {
    return setReadMore(function (prevState) {
      return !prevState;
    });
  });

  var handleOpenFOP = function handleOpenFOP(type, item) {
    setSelectedForFoP(item);
    setModalData(type);
  };

  var collectionName = useMemo(function () {
    var _product$custom_attri, _nameAttribute$select, _nameAttribute$select2, _nameAttribute$select3;

    var nameAttribute = (_product$custom_attri = product.custom_attributes) === null || _product$custom_attri === void 0 ? void 0 : _product$custom_attri.find(function (customAttribute) {
      var _customAttribute$attr;

      return (customAttribute === null || customAttribute === void 0 ? void 0 : (_customAttribute$attr = customAttribute.attribute_metadata) === null || _customAttribute$attr === void 0 ? void 0 : _customAttribute$attr.code) === 'hf_family';
    });
    return nameAttribute === null || nameAttribute === void 0 ? void 0 : (_nameAttribute$select = nameAttribute.selected_attribute_options) === null || _nameAttribute$select === void 0 ? void 0 : (_nameAttribute$select2 = _nameAttribute$select.attribute_option) === null || _nameAttribute$select2 === void 0 ? void 0 : (_nameAttribute$select3 = _nameAttribute$select2[0]) === null || _nameAttribute$select3 === void 0 ? void 0 : _nameAttribute$select3.label;
  }, [relatedProducts]);
  var filteredCollectionsByProduct = collectionsData === null || collectionsData === void 0 ? void 0 : collectionsData.find(function (item) {
    var _item$collection_url, _item$collection_url2;

    var replaceValue = ((_item$collection_url = item.collection_url) === null || _item$collection_url === void 0 ? void 0 : _item$collection_url.toLowerCase()) === 'art-alchemy' ? ' + ' : ' ';
    return ((_item$collection_url2 = item.collection_url) === null || _item$collection_url2 === void 0 ? void 0 : _item$collection_url2.toLowerCase().replace('-', replaceValue).trim()) === (collectionName === null || collectionName === void 0 ? void 0 : collectionName.toLowerCase());
  });
  var isAddedToFop = fopData === null || fopData === void 0 ? void 0 : (_fopData$customer = fopData.customer) === null || _fopData$customer === void 0 ? void 0 : (_fopData$customer$req = _fopData$customer.requisition_lists) === null || _fopData$customer$req === void 0 ? void 0 : (_fopData$customer$req2 = _fopData$customer$req.items) === null || _fopData$customer$req2 === void 0 ? void 0 : _fopData$customer$req2.some(function (item) {
    var _item$items, _item$items$items;

    return item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : (_item$items$items = _item$items.items) === null || _item$items$items === void 0 ? void 0 : _item$items$items.some(function (item) {
      return item.product.sku === configuredItemId;
    });
  });
  var additionalFeatureAttributesPool = ['hf_option1', 'hf_lamping', 'hf_adacompliant', 'hf_sloped_ceiling', 'hf_dark_sky_friendly', 'hf_patent', // 'Title 24 Compliant [If Title24 value positive]',
  // 'Title 20 Compliant [If Title20 value positive]',
  // 'hf_overall_height',
  // 'hf_cable_hung', //'Includes adjustable cable and canopy kit [If CableHung value of “1”]',
  // 'hf_down_rod_count', //'Includes adjustable stem and canopy kit [If DownrodCount value positive]',
  'hf_turtle_friendly' // not present yet in data
  ];
  var additionalFeatureAttributes = configCustomAttributes === null || configCustomAttributes === void 0 ? void 0 : configCustomAttributes.filter(function (attr) {
    var _product$configurable4;

    return additionalFeatureAttributesPool.includes(attr.attribute_metadata.code) && !((_product$configurable4 = product.configurable_options) !== null && _product$configurable4 !== void 0 && _product$configurable4.find(function (option) {
      return option.attribute_code == attr.attribute_metadata.code;
    }));
  }).filter(function (attr) {
    return !(attr.attribute_metadata.code == 'hf_lamping' && attr.selected_attribute_options.attribute_option[0].label.includes('None') || attr.attribute_metadata.code == 'hf_adacompliant' && attr.selected_attribute_options.attribute_option[0].label == 'No' || attr.attribute_metadata.code == 'hf_dark_sky_friendly' && attr.selected_attribute_options.attribute_option[0].label == 'No' || attr.attribute_metadata.code == 'hf_sloped_ceiling' && attr.selected_attribute_options.attribute_option[0].label == 'No (0)' || attr.attribute_metadata.code == 'hf_patent' && attr.entered_attribute_value.value == 'No');
  });
  var featuresContent = isOutletProduct && (additionalFeatureAttributes === null || additionalFeatureAttributes === void 0 ? void 0 : additionalFeatureAttributes.length) > 0 ? React.createElement("div", {
    className: "mt-4 md_mt-0 mb-10"
  }, isMobile ? React.createElement(Accordion, {
    classes: {
      wrapper: classes.accordionWrapper,
      title: classes.accordionTitle,
      closeIcon: classes.accordionCloseIcon
    },
    title: "Features",
    content: React.createElement("ul", {
      className: classes.feturesList
    }, additionalFeatureAttributes === null || additionalFeatureAttributes === void 0 ? void 0 : additionalFeatureAttributes.map(function (item, idx) {
      return React.createElement(AdditionalFeatureItem, {
        key: idx,
        data: item
      });
    })),
    openIcon: React.createElement(DownArrow, null)
  }) : React.createElement(React.Fragment, null, React.createElement(SectionTitle, {
    title: "Features"
  }), React.createElement("ul", {
    className: classes.feturesList
  }, additionalFeatureAttributes === null || additionalFeatureAttributes === void 0 ? void 0 : additionalFeatureAttributes.map(function (item, idx) {
    return React.createElement(AdditionalFeatureItem, {
      key: idx,
      data: item
    });
  })))) : null;
  var isFrequentlyOrderedPermitted = !isConsumer && !isHfEmployee && !isResReps && !isResDesigner && !isTradeDirectAccount && !isComPurchasing && !isComNonPurchasing;
  var videoGallery = useMemo(function () {
    var _product$hf_video_gal;

    return product !== null && product !== void 0 && product.hf_video_gallery ? product === null || product === void 0 ? void 0 : (_product$hf_video_gal = product.hf_video_gallery) === null || _product$hf_video_gal === void 0 ? void 0 : _product$hf_video_gal.split(',') : null;
  }, [product === null || product === void 0 ? void 0 : product.hf_video_gallery]);
  var familyCustomPdfsElements = !!(product !== null && product !== void 0 && (_product$custom_attri2 = product.custom_attributes) !== null && _product$custom_attri2 !== void 0 && (_product$custom_attri3 = _product$custom_attri2.find(function (item) {
    return item.attribute_metadata.code == 'hf_custom_pdfs';
  })) !== null && _product$custom_attri3 !== void 0 && (_product$custom_attri4 = _product$custom_attri3.entered_attribute_value) !== null && _product$custom_attri4 !== void 0 && _product$custom_attri4.value);
  var priceContent = React.createElement("div", {
    className: "grow flex 2xl_flex 2xl_items-baseline"
  }, (product === null || product === void 0 ? void 0 : (_product$price_range = product.price_range) === null || _product$price_range === void 0 ? void 0 : (_product$price_range$ = _product$price_range.maximum_price) === null || _product$price_range$ === void 0 ? void 0 : (_product$price_range$2 = _product$price_range$.final_price) === null || _product$price_range$2 === void 0 ? void 0 : _product$price_range$2.value) < (product === null || product === void 0 ? void 0 : (_product$price_range2 = product.price_range) === null || _product$price_range2 === void 0 ? void 0 : (_product$price_range3 = _product$price_range2.maximum_price) === null || _product$price_range3 === void 0 ? void 0 : (_product$price_range4 = _product$price_range3.regular_price) === null || _product$price_range4 === void 0 ? void 0 : _product$price_range4.value) && React.createElement(React.Fragment, null, React.createElement(Price, {
    currencyCode: product === null || product === void 0 ? void 0 : (_product$price_range5 = product.price_range) === null || _product$price_range5 === void 0 ? void 0 : (_product$price_range6 = _product$price_range5.maximum_price) === null || _product$price_range6 === void 0 ? void 0 : (_product$price_range7 = _product$price_range6.regular_price) === null || _product$price_range7 === void 0 ? void 0 : _product$price_range7.currency,
    value: product === null || product === void 0 ? void 0 : (_product$price_range8 = product.price_range) === null || _product$price_range8 === void 0 ? void 0 : (_product$price_range9 = _product$price_range8.maximum_price) === null || _product$price_range9 === void 0 ? void 0 : (_product$price_range10 = _product$price_range9.regular_price) === null || _product$price_range10 === void 0 ? void 0 : _product$price_range10.value,
    classes: {
      root: classes.oldPriceStyle
    }
  }), React.createElement("div", {
    className: classes.resRegPrice
  }, React.createElement("span", {
    className: classes.costText
  }, "From: "), React.createElement(Price, {
    currencyCode: productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$price = productDetails.price) === null || _productDetails$price === void 0 ? void 0 : _productDetails$price.currency,
    value: productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$price2 = productDetails.price) === null || _productDetails$price2 === void 0 ? void 0 : _productDetails$price2.value,
    classes: {
      root: isOutletProduct && (product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$regula = _product$price.regularPrice) === null || _product$price$regula === void 0 ? void 0 : (_product$price$regula2 = _product$price$regula.amount) === null || _product$price$regula2 === void 0 ? void 0 : _product$price$regula2.value) > productDetails.price.value ? classes.priceStyle : classes.regularPriceStyle
    }
  }))), !((product === null || product === void 0 ? void 0 : (_product$price_range11 = product.price_range) === null || _product$price_range11 === void 0 ? void 0 : (_product$price_range12 = _product$price_range11.maximum_price) === null || _product$price_range12 === void 0 ? void 0 : (_product$price_range13 = _product$price_range12.final_price) === null || _product$price_range13 === void 0 ? void 0 : _product$price_range13.value) < (product === null || product === void 0 ? void 0 : (_product$price_range14 = product.price_range) === null || _product$price_range14 === void 0 ? void 0 : (_product$price_range15 = _product$price_range14.maximum_price) === null || _product$price_range15 === void 0 ? void 0 : (_product$price_range16 = _product$price_range15.regular_price) === null || _product$price_range16 === void 0 ? void 0 : _product$price_range16.value)) && React.createElement(Price, {
    currencyCode: productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$price3 = productDetails.price) === null || _productDetails$price3 === void 0 ? void 0 : _productDetails$price3.currency,
    value: productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$price4 = productDetails.price) === null || _productDetails$price4 === void 0 ? void 0 : _productDetails$price4.value,
    classes: {
      root: classes.regularPriceStyle
    }
  }));
  var candidElement = React.createElement("section", {
    className: "social-media"
  }, React.createElement(GetCandid, {
    candidId: 'dc0bede0-4df3-494a-976f-b5f67a208356',
    candidTheme: 'ct-minimal',
    count: 15,
    imageWidth: innerWidth > 1441 ? 274 : innerWidth > 1024 ? 225 : innerWidth > 768 ? 180 : 500,
    margin: 22,
    isPdp: true,
    fullWidth: true,
    sortBy: "custom",
    term: product.sku,
    productUrl: "https://www.hubbardtonforge.com/".concat(product.sku),
    showCommunityUploadButton: true,
    familly: collectionName
  }));
  var productTags = useMemo(function () {
    var _configCustomAttribut2, _configCustomAttribut3;

    return configCustomAttributes === null || configCustomAttributes === void 0 ? void 0 : (_configCustomAttribut2 = configCustomAttributes.filter(function (attr) {
      var _ref2, _attr$attribute_metad;

      return (_ref2 = ['hf_best_seller', 'hf_designer_preference', 'hf_new_designs']) === null || _ref2 === void 0 ? void 0 : _ref2.includes(attr === null || attr === void 0 ? void 0 : (_attr$attribute_metad = attr.attribute_metadata) === null || _attr$attribute_metad === void 0 ? void 0 : _attr$attribute_metad.code);
    })) === null || _configCustomAttribut2 === void 0 ? void 0 : (_configCustomAttribut3 = _configCustomAttribut2.map(function (value) {
      var _value$attribute_meta, _value$attribute_meta2, _value$attribute_meta3;

      return {
        value: tagValues[value === null || value === void 0 ? void 0 : (_value$attribute_meta = value.attribute_metadata) === null || _value$attribute_meta === void 0 ? void 0 : _value$attribute_meta.code],
        code: value === null || value === void 0 ? void 0 : (_value$attribute_meta2 = value.attribute_metadata) === null || _value$attribute_meta2 === void 0 ? void 0 : _value$attribute_meta2.code,
        label: value === null || value === void 0 ? void 0 : (_value$attribute_meta3 = value.attribute_metadata) === null || _value$attribute_meta3 === void 0 ? void 0 : _value$attribute_meta3.label
      };
    })) === null || _configCustomAttribut3 === void 0 ? void 0 : _configCustomAttribut3.sort(function (a, b) {
      return a.code === 'hf_new_designs' ? -1 : a.code === 'hf_designer_preference' ? -1 : 1;
    });
  }, [(product, configCustomAttributes, tagValues)]);
  return React.createElement(Fragment, null, React.createElement(AppBodyLayout, null, React.createElement("div", null, React.createElement(Form, {
    className: "grid grid-cols-12 pt-10 md_pb-20 2xl_gap-x-[60px] xl_gap-x-[40px] md_gap-x-[30px] gap-x-5 relative",
    onSubmit: handleAddToCart,
    onChange: function onChange(e) {
      var _e$values;

      return setLocalQuantity(e === null || e === void 0 ? void 0 : (_e$values = e.values) === null || _e$values === void 0 ? void 0 : _e$values.quantity);
    }
  }, React.createElement("section", {
    className: "".concat(classes.imageCarousel, " relative")
  }, isOutletProduct && React.createElement("div", {
    className: classes.outletMark
  }, "OUTLET"), React.createElement(ProductSlider, {
    images: mediaGallery,
    scaledImages: mediaGallery,
    handleResetProductConfiguration: handleResetProductConfiguration,
    threeSixtyLink: product === null || product === void 0 ? void 0 : product.hf_three_sixty_embed_link,
    toggleDrawer: toggleDrawer,
    videoGallery: videoGallery,
    optionSelections: optionSelections,
    productName: productDetails.name,
    defaultSmartStringSelected: defaultSmartStringSelected,
    configuredSmartString: configuredSmartString,
    options: derivedConfigOptions,
    setOptionSelections: setOptionSelections,
    isMobile: isMobile,
    setProductConfiguration: setProductConfiguration
  })), React.createElement("div", {
    className: classes.detailsSection
  }, React.createElement("section", {
    className: "".concat(classes.title, " ").concat(classes.productTitle)
  }, breadcrumbs, isMobile ? null : React.createElement("div", {
    className: classes.breadcrumbDivider
  }), isOutletProduct && React.createElement("span", {
    className: classes.aboveName
  }, "OUTLET"), React.createElement("h3", {
    className: classes.productName
  }, productDetails.name), React.createElement("div", {
    className: classes.itemsDesc
  }, React.createElement("h6", {
    className: "text-black text-18 md_text-h6 leading-160"
  }, "Base Item #", productDetails.sku), React.createElement("div", {
    className: classes.tagsWrapper
  }, productTags === null || productTags === void 0 ? void 0 : productTags.map(function (tag) {
    return tag.value ? React.createElement("span", {
      className: classes.tag
    }, tag.label) : null;
  }))), priceContent), React.createElement("div", {
    id: "specifications"
  }, React.createElement(Specifications, {
    productDetails: productDetails,
    customAttributes: customAttributes,
    weight: weight,
    product: product,
    configCustomAttributes: configCustomAttributes,
    isOutletProduct: isOutletProduct,
    installationSheetUrl: customAttributes === null || customAttributes === void 0 ? void 0 : (_customAttributes$fin = customAttributes.find(function (item) {
      return item.attribute_metadata.code == 'hf_installation_instructions';
    })) === null || _customAttributes$fin === void 0 ? void 0 : (_customAttributes$fin2 = _customAttributes$fin.entered_attribute_value) === null || _customAttributes$fin2 === void 0 ? void 0 : _customAttributes$fin2.value,
    isCustomerServiceTeam: isCustomerServiceTeam
  })), React.createElement("div", {
    className: classes.actionButtons
  }, React.createElement("button", {
    priority: "normal",
    type: "button",
    fullWidth: true,
    onClick: function onClick() {
      return handleDrawerActions('DOWNLOADS');
    },
    className: classes.normalButton,
    "aria-label": "Downloads"
  }, React.createElement("img", {
    src: downloadIcon,
    alt: "download-icon"
  }), React.createElement("span", {
    className: "ml-2"
  }, "DOWNLOADS")), React.createElement("button", {
    priority: "normal",
    fullWidth: true,
    type: "button",
    onClick: function onClick() {
      return handleDrawerActions('CUSTOM');
    },
    className: classes.normalButton,
    "aria-label": "Custom"
  }, React.createElement("img", {
    src: editIcon,
    alt: "download-icon"
  }), React.createElement("span", {
    className: "ml-2"
  }, "CUSTOM"))), options, isProductConfigurable(product) && React.createElement(ItemSkuInfo, {
    itemId: configuredItemId,
    smartString: configuredSmartString,
    product: productDetails
  }), featuresContent, React.createElement("div", {
    className: classes.border
  }), !isOutletProduct && React.createElement(React.Fragment, null, React.createElement(FormError, {
    classes: {
      root: classes.formErrors
    },
    errors: errors.get('form') || []
  }), React.createElement("section", {
    className: "flex md_flex-row flex-col gap-3 justify-between mt-8 md_mb-11 mb-6 flex-wrap"
  }, priceContent, React.createElement("div", {
    className: "flex items-center"
  }, React.createElement(Suspense, {
    fallback: null
  }, isUserSignedIn && isFrequentlyOrderedPermitted && React.createElement(Trigger, {
    action: function action() {
      return handleOpenFOP('ADD_FREQUENTLY_ORDER', product);
    },
    classes: {
      root: 'underline text-left text-bronze font-bold mt-1 md_mt-0 mr-4 xl_max-w-[130px]'
    },
    "aria-label": "Frequently order"
  }, isAddedToFop ? 'Update Frequently Ordered Products' : '+Frequently Ordered'), React.createElement(WishlistButton, _extends({}, wishlistButtonProps, {
    isWishlistDialogOpen: isWishlistDialogOpen,
    setIsWishlistDialogOpen: setIsWishlistDialogOpen,
    isPdp: true,
    setModalData: handleOpenModal,
    product: product,
    selectedOptionsArray: selectedOptionsArray,
    isInFavorites: isInFavorites,
    refetchFavorites: refetchFavorites,
    configuredVariant: configuredVariant
  }))))), React.createElement("section", {
    className: classes.quantityHolder
  }, isSaleable && React.createElement(QuantityFields, {
    min: 1,
    message: errors.get('quantity'),
    classes: {
      root: classes.rootLabel,
      input: classes.qtyInput
    }
  })), React.createElement("section", {
    className: "flex mt-3 xl_justify-between flex-wrap"
  }, canViewPricingAndPurchase && (isOutletProduct || otherUser || isCustomerServiceTeam) && cartActionContent, isUserSignedIn && !isOutletProduct && !isConsumer && !isResReps && !isResDesigner && !isCustomerServiceTeam && !otherUser ? addToQuotesBtn : null, (!isUserSignedIn || isConsumer || isResReps || isResDesigner) && !isOutletProduct && onlineLocalBtns), !isUserSignedIn && React.createElement("div", {
    className: "py-3 flex justify-between items-center"
  }, React.createElement("p", {
    className: "font-bold text-[16px]"
  }, "For Professional Accounts"), React.createElement(Link, {
    to: "/sign-in",
    className: "uppercase underline"
  }, "Log in or create a web profile")), React.createElement("div", {
    className: "".concat(classes.description, " ").concat(!isUserSignedIn && 'mt-0')
  }, React.createElement("p", {
    className: "font-bold"
  }, "Description"), React.createElement("div", {
    className: "leading-171 mb-4 text-bronze text-sm"
  }, React.createElement("span", {
    className: "".concat(classes.shorterDescription, " ").concat(isReadMore ? classes.expanded : classes.notExpanded)
  }, React.createElement(RichContent, {
    html: productDetails.description
  })))), isMobile && candidElement, isAvailableInOutletLink ? React.createElement("div", {
    className: classes.availableOutlet
  }, React.createElement("div", {
    className: "mr-4 text-[1.25rem] text-red"
  }, "PRODUCT AVAILABLE IN OUTLET"), React.createElement(Link, {
    to: "/".concat(isAvailableInOutletLink),
    "aria-label": "View ".concat(productDetails.name, " Outlet page")
  }, "VIEW")) : null), isOutletProduct && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex items-center justify-between  mb-4 mt-10"
  }, React.createElement(Trigger, {
    classes: {
      root: 'text-bronze underline font-bold'
    },
    action: function action() {
      return window.scroll({
        top: document.getElementById('specifications').offsetTop - 100,
        behavior: 'smooth'
      });
    }
  }, "Specifications"), React.createElement(DownloadsPopup, {
    isOutlet: true,
    product: product,
    installationSheetUrl: customAttributes === null || customAttributes === void 0 ? void 0 : (_customAttributes$fin3 = customAttributes.find(function (item) {
      return item.attribute_metadata.code == 'hf_installation_instructions';
    })) === null || _customAttributes$fin3 === void 0 ? void 0 : (_customAttributes$fin4 = _customAttributes$fin3.entered_attribute_value) === null || _customAttributes$fin4 === void 0 ? void 0 : _customAttributes$fin4.value
  })), React.createElement("div", {
    className: classes.whatsAvailable,
    onClick: function onClick() {
      var _availableRef$current;

      return window.scroll({
        top: ((_availableRef$current = availableRef.current) === null || _availableRef$current === void 0 ? void 0 : _availableRef$current.offsetTop) - 100,
        behavior: 'smooth'
      });
    }
  }, React.createElement("h6", null, "See What\u2019s Available"), React.createElement("div", {
    className: "border border-[#cbcbcb] mt-[6px] mb-4 w-full"
  }), React.createElement("img", {
    src: arrowDown,
    alt: "arrow-down"
  }))))), !isMobile && candidElement, React.createElement("section", {
    className: classes.availableOutlet,
    ref: availableRef
  }, isOutletProduct && React.createElement(AvailableOutlet, {
    outletSku: product.sku,
    product: product,
    customAttributes: customAttributes,
    wishlistButtonProps: wishlistButtonProps,
    isWishlistDialogOpen: isWishlistDialogOpen,
    setIsWishlistDialogOpen: setIsWishlistDialogOpen,
    isPdp: true,
    setModalData: handleOpenModal
  })), React.createElement("section", {
    className: "col-span-12"
  }, !isOutletProduct && !!(relatedProducts !== null && relatedProducts !== void 0 && (_relatedProducts$cros = relatedProducts.crosssell_products) !== null && _relatedProducts$cros !== void 0 && _relatedProducts$cros.length) && React.createElement(ProductListSlider, {
    products: relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.crosssell_products,
    title: 'Also in this collection',
    isCollection: true,
    collectionUrlKey: filteredCollectionsByProduct !== null && filteredCollectionsByProduct !== void 0 && filteredCollectionsByProduct.collection_url ? "/collection-landing/".concat(filteredCollectionsByProduct.collection_url) : ''
  })), React.createElement("section", {
    className: classes.overviewSection
  }, React.createElement("div", {
    className: "col-span-12"
  }, storyPosition1, storyPosition2, storyPosition3, storyPosition4))), storyPosition5), isSignInModalOpen && React.createElement(SignInModal, {
    isOpen: isSignInModalOpen,
    item: product,
    closeModal: closeModal,
    itemOption: wishlistButtonProps === null || wishlistButtonProps === void 0 ? void 0 : wishlistButtonProps.item
  }), React.createElement(Tearsheet, {
    isOpen: isTearsheetOpen,
    productDetails: productDetails,
    customAttributes: customAttributes,
    disabledValuesMap: disabledValuesMap,
    product: product,
    optionSelections: optionSelections,
    itemId: configuredItemId,
    smartString: configuredSmartString,
    weight: weight,
    showPdfOptions: showPdfOptions
  }), (activateDrawer === null || activateDrawer === void 0 ? void 0 : activateDrawer.type) && React.createElement(Drawer, {
    ref: drawerRef,
    type: activateDrawer.type,
    option: activateDrawer.data,
    close: closeDrawer,
    onSelectionChange: handleSelectionChange,
    product: product,
    customAttributes: customAttributes
  }), isMiddleDialogOpen && React.createElement(MiddleDialog, {
    setIsWishlistDialogOpen: setIsWishlistDialogOpen,
    autoClose: closeModal
  }), !isOutletProduct && isFOPOpen && React.createElement(FrequentlyOrderedModal, {
    selectedItem: selectedForFoP,
    isOpen: isFOPOpen,
    closeModal: closeModal,
    fopData: fopData,
    refetch: refetch,
    loadingReq: loadingReq,
    productSku: configuredItemId || product.sku
  }), videoModal ? React.createElement(VideoComponent, {
    isOpen: videoModal,
    videoName: productDetails.name,
    closeDrawer: defaultCloseDrawer,
    videoGallery: videoGallery
  }) : null);
};

ProductFullDetail.propTypes = {
  classes: shape({
    cartActions: string,
    description: string,
    descriptionTitle: string,
    details: string,
    detailsTitle: string,
    imageCarousel: string,
    options: string,
    productName: string,
    productPrice: string,
    quantity: string,
    quantityTitle: string,
    root: string,
    title: string,
    unavailableContainer: string
  }),
  product: shape({
    __typename: string,
    id: number,
    stock_status: string,
    sku: string.isRequired,
    price_range: shape({
      maximum_price: shape({
        final_price: shape({
          currency: string.isRequired,
          value: number.isRequired
        }),
        regular_price: shape({
          currency: string.isRequired,
          value: number.isRequired
        })
      }).isRequired
    }).isRequired,
    media_gallery_entries: arrayOf(shape({
      uid: string,
      label: string,
      position: number,
      disabled: bool,
      file: string.isRequired
    })),
    description: string
  }).isRequired
};
export default ProductFullDetail;